import React from 'react'
import Image from 'next/image'
import styles from './vehicleBanner.module.scss'
import { AUTO_DATA_FALLBACK, VEHICLE_BANNER_ALT } from './commonConstants'
import { VEHICLE_BANNER_IMG } from './widgetImagesConstant'
import { commonWidgetConfig } from './commonWidgetConfig'

interface AutoData {
  db_make_name: string
  db_model_name: string
}

interface VehicleBannerProps {
  autoData?: AutoData
  regNo: string
  isLoginBanner?: boolean
  widgetType?: string
}

const VehicleBanner = ({
  autoData = AUTO_DATA_FALLBACK,
  regNo,
  isLoginBanner = false,
  widgetType = 'default'
}: VehicleBannerProps) => {
  const { db_make_name: dbMakeName, db_model_name: dbModelName } = autoData
  return (
    <div>
      {isLoginBanner ? (
        <>
          <span className={styles.loginWidgetText}>{commonWidgetConfig.loginText[widgetType]}</span>
          <div className={styles.fastagVehicleDetailsWrapperLogin}>
            <div className={styles.fastagVehicleDetailsFlex}>
              <div className={styles.vehicleModal}>
                <span>{regNo}</span>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className={styles.fastagVehicleDetailsWrapper}>
          <div className={styles.fastagVehicleDetailsFlex}>
            <div className={styles.vehicleModal}>
              {Object.keys(autoData)?.length ? (
                <p>
                  {dbMakeName} {dbModelName}
                </p>
              ) : null}
              <span>{regNo}</span>
            </div>
          </div>
          <Image
            width={162}
            height={75}
            layout="fixed"
            className={styles.carImg}
            src={VEHICLE_BANNER_IMG}
            alt={VEHICLE_BANNER_ALT}
          />
        </div>
      )}
    </div>
  )
}

export default VehicleBanner
